import { AppContext, Login as LogIn } from "@ctsu/loader";
import { ShowPublicNotifications } from "@ctsu/react-ctsu-ui";
import DocumentTitle from "components/common/DocumentTitle";
import { text } from "components/common/Text";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import About from "./MyTask/About";

export default function Login() {
  const context = useContext(AppContext);
  return (
    <>
      <DocumentTitle title="Login Page" />
      <ShowPublicNotifications
        appName={`${process.env.REACT_APP_NAME}`}
        appOrigin={`${process.env.REACT_APP_ORIGIN}`}
        coreVersion={`${process.env.REACT_APP_PERSON_API_VERSION}`}
        context={context}
      />
      <div className="app-body-main mt-2">
        <div className="app-body-center">
          <div className="row col-12 p-4 bg-white shadow-sm align-items-center?" style={{ margin: "auto" }}>
            <div className="col-6 mr-4">
              <div className="app-welcome-title color-blue">{text("login.welcome")}</div>
              <About />
            </div>
            <div className="col-6 p-4 rounded align-center ctep-login-wrapper">
              <div className="content-page-title color-dark-blue">{text("login.ctep_iam_login")}</div>
              <LogIn page={<Navigate to="/" />} height="400px" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
